import { render } from "./DepositObjectivePayment.vue?vue&type=template&id=5ae317a7&scoped=true"
import script from "./DepositObjectivePayment.vue?vue&type=script&lang=js"
export * from "./DepositObjectivePayment.vue?vue&type=script&lang=js"

import "./DepositObjectivePayment.vue?vue&type=style&index=0&id=5ae317a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae317a7"]])

export default __exports__